import { displayDate } from "~/plugins/functions/display";

// For DTO Preset
export interface IModelGETWorkflowRuntimeRequest {
  orderBy: string;
  orderType: string;
  count: boolean;
  page: number;
  limit: number;
}

// For DTO Workflow
export interface IModelGETWorkflowRuntimeResponse {
  id: number;
  className: string;
  runtime: string;
  nodes: string;
  edges: string;
  viewport: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
}

export class ModelGETWorkflowRuntime {
  id: number;
  className: string;
  runtime: string;
  nodes: string;
  edges: string;
  viewport: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;

  nodeList: any;
  edgeList: any;
  displayCreatedAt: string;
  displayUpdatedAt: string;

  constructor(props = {} as IModelGETWorkflowRuntimeResponse) {
    props = props ?? {} as IModelGETWorkflowRuntimeResponse;
    this.id = props.id || 0;
    this.className = props.className || '';
    this.runtime = props.runtime || '';
    this.nodes = props.nodes;
    this.edges = props.edges;
    this.viewport = props.viewport || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;

    this.nodeList = this.nodes ? JSON.parse(this.nodes) : [];
    this.edgeList = this.edges ? JSON.parse(this.edges) : [];
    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
  }
}

// For DTO Workflow
export interface IModelGETWorkflowRuntimeIdResponse {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
  viewport: string;
}

export class ModelGETWorkflowRuntimeId {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
  viewport: string;

  nodeList: any;
  edgeList: any;

  constructor(props = {} as IModelGETWorkflowRuntimeIdResponse) {
    props = props ?? {} as IModelGETWorkflowRuntimeIdResponse;
    this.id = props.id || 0;
    this.runtime = props.runtime || '';
    this.nodes = props.nodes;
    this.edges = props.edges;
    this.viewport = props.viewport || '';

    this.nodeList = this.nodes ? JSON.parse(this.nodes) : [];
    this.edgeList = this.edges ? JSON.parse(this.edges) : [];
  }
}

// For PUT DTO Workflow
export interface IModelPUTWorkflowRuntimeRequest {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
}

export interface IModelPOSTWorkflowRuntimeRequest {
  runtime: string;
  nodes: string;
  edges: string;
}

